import { IconProps } from './types';

export function Notifications({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 25 25" {...props}>
      <path
        fill="currentColor"
        d="M19.352 9.25c-2.07 0-3.75-1.68-3.75-3.75 0-2.07 1.68-3.75 3.75-3.75 2.07 0 3.75 1.68 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75Zm0-6c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25 2.25-1.01 2.25-2.25-1.01-2.25-2.25-2.25Z"
      />
      <path
        fill="currentColor"
        d="M12.352 23.25c-5.93 0-10.75-4.82-10.75-10.75s4.82-10.75 10.75-10.75c.73 0 1.46.07 2.17.22.41.08.67.48.58.89-.08.41-.48.67-.88.58a8.99 8.99 0 0 0-1.87-.19c-5.1 0-9.25 4.15-9.25 9.25s4.15 9.25 9.25 9.25 9.25-4.15 9.25-9.25c0-.62-.06-1.24-.18-1.84-.08-.41.18-.8.59-.88.41-.09.8.18.88.59.14.7.21 1.42.21 2.14 0 5.92-4.82 10.74-10.75 10.74Z"
      />
    </svg>
  );
}
